var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnCompleteProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tailwind Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 147",
    cx: 10,
    cy: 10,
    r: 7.5,
    fill: "white",
    stroke: "#F5A524"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnCompleteProgress);
export default __webpack_public_path__ + "static/media/un-complete-progress.d501f512c08b5725c111800cc2ec6856.svg";
export { ForwardRef as ReactComponent };